import { render, staticRenderFns } from "./serviceBtn.vue?vue&type=template&id=7c990df2&scoped=true&"
import script from "./serviceBtn.vue?vue&type=script&lang=js&"
export * from "./serviceBtn.vue?vue&type=script&lang=js&"
import style0 from "./serviceBtn.vue?vue&type=style&index=0&id=7c990df2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c990df2",
  null
  
)

export default component.exports